import template from './dashboard-objects-filter.component.html';
import type { InteractiveFilter } from '../../InteractiveFilter.model';
import type { IComponentController, IScope } from 'angular';

interface SelectedItem {
	Id: string;
	DisplayString: string;
}

export class DashboardObjectsFilterController implements IComponentController {
	filter!: InteractiveFilter;
	value?: string | string[] | null;
	selectedItems: SelectedItem[] = [];
	selectedItem?: SelectedItem | null;

	static readonly $inject = ['$scope'];

	constructor(private readonly $scope: IScope) {}

	$onInit() {
		this.handleExternalChanges();

		this.$scope.$watch(
			'vm.selectedItems',
			(selectedItems: SelectedItem[]) => {
				this.handleChanges(selectedItems, this.normalizeValue(this.value));
			},
			true
		);

		this.$scope.$watch(
			'vm.selectedItem',
			(selectedItem?: SelectedItem) => {
				this.handleChanges(selectedItem ? [selectedItem] : [], this.normalizeValue(this.value));
			},
			true
		);

		this.$scope.$watch('vm.value', (value: string[] | undefined | null) => {
			if (this.isValueChanged()) {
				this.handleChanges(this.selectedItems, value);
			}
		});

		this.filter.onChange(() => {
			this.handleExternalChanges();
		});
	}

	private normalizeValue(value: string[] | string | null | undefined): string[] {
		if (typeof value === 'string' && value.length > 0) {
			return [value];
		}

		return Array.isArray(value) ? value : [];
	}

	private isValueChanged(): boolean {
		return this.normalizeValue(this.value).toSorted().join(',') !== this.filter.value?.toSorted().join(',');
	}

	private handleExternalChanges() {
		if (this.isValueChanged()) {
			const value = (this.filter.value ?? []) as string[];
			if (this.filter.isMultiPicker) {
				this.value = value;
			} else {
				this.value = value?.[0] ?? null;
			}
		}
	}

	private handleChanges(selectedItems: SelectedItem[], value: string[] | undefined | null) {
		if ((selectedItems ?? []).length !== (value ?? []).length) {
			return;
		}

		if (selectedItems.length) {
			this.filter.setValue(
				selectedItems.map((item) => item.Id),
				this.filter.operators.In.getFullLabel(
					this.filter.title,
					selectedItems.map((item) => item.DisplayString)
				)
			);
		} else {
			this.filter.clear();
		}
	}
}

export const DashboardObjectsFilterComponent = {
	name: 'mxDashboardObjectsFilter',
	controller: DashboardObjectsFilterController,
	controllerAs: 'vm',
	template,
	bindings: {
		filter: '<',
	},
};
